module.exports = __webpack_public_path__ + "img/icon_map_199_on_110.e90c911c.png";